<span class="fas pointer float-right custom-collapsable keyboard-accessible" style="font-size:initial;margin-top:0.2em"
    (click)="collapsed=!collapsed;onChange($event)" [ngClass]="{
        'fa-chevron-down': collapsed, 
        'fa-chevron-up': !collapsed, 
        'custom-collapsable': storageKey !== 'header' && storageKey !== 'case-events', 
        'custom-collapsable-header': storageKey === 'header' || storageKey === 'case-events'}" [title]="getTitle()"
    [attr.aria-label]="getTitle()" [attr.aria-expanded]="!collapsed" tabindex="0"
    (keydown.enter)="collapsed=!collapsed;onChange($event)" (keydown.space)="collapsed=!collapsed;onChange($event)"
    role="button">
</span>